import { apply, put, delay, select } from 'redux-saga/effects';
import { errorNotification } from '../reducers/notification.reducers';
import {
  loadOrdersSucceeded,
  loadOrdersFailed,
  loadOrderSucceeded,
  loadOrderFailed,
  removeObsoleteOrders,
  selectOrder,
  proceedOrder as proceedOrderAction,
} from '../reducers/order.reducers';

// eslint-disable-next-line import/prefer-default-export
export function* loadOrders(orderApi) {
  try {
    const response = yield apply(
      orderApi,
      orderApi.loadOrders,
    );

    if (response.errorCode) {
      yield put(loadOrdersFailed({ message: response.message || 'Failed to login' }));
      yield put(errorNotification(response.message || 'Failed to login'));
    } else {
      yield put(loadOrdersSucceeded({ orders: response }));
    }
  } catch (e) {
    yield put(loadOrdersFailed({ message: 'Failed to login' }));
  }
}

export function* loadOrder(orderApi, { payload }) {
  try {
    const response = yield apply(
      orderApi,
      orderApi.loadOrder,
      [payload],
    );

    if (response.errorCode) {
      yield put(loadOrderFailed(payload));
      yield put(errorNotification(response.message || 'Failed to load order'));
    } else {
      yield put(loadOrderSucceeded({ order: response }));
      yield delay(300);
      yield put(removeObsoleteOrders());
    }
  } catch (e) {
    yield put(loadOrdersFailed(payload));
  }
}

export function* proceedOrder(orderApi, { payload }) {
  try {
    const response = yield apply(
      orderApi,
      orderApi.proceedOrder,
      [payload],
    );

    if (response.errorCode) {
      yield put(errorNotification(response.message || 'Failed to proceed order'));
    }
  } catch (e) {
    yield put(errorNotification('Failed to proceed order'));
  }
}

export function* declineOrder(orderApi, { payload }) {
  try {
    const response = yield apply(
      orderApi,
      orderApi.declineOrder,
      [payload],
    );

    if (response.errorCode) {
      yield put(errorNotification(response.message || 'Failed to decline order'));
    }
  } catch (e) {
    yield put(errorNotification('Failed to decline order'));
  }
}

export function* handleScan(orderApi, { payload }) {
  if (!payload) {
    return;
  }

  let cleanedPayload = payload.trim();

  if (cleanedPayload.length > 36) {
    cleanedPayload = cleanedPayload.slice(cleanedPayload.length - 36);
  }

  cleanedPayload = cleanedPayload.replace(/[^0-9]+/g, '');

  const orders = yield select(state => state.orders.orders);

  const order = orders.find(o => o.guid && o.guid.replace(/[^0-9]+/g, '') === cleanedPayload);

  if (order == null) {
    yield put(errorNotification('Bestellung nicht gefunden!'));
    return;
  }

  yield put(selectOrder(order));
  yield put(proceedOrderAction(order.id));

  yield delay(4000);

  const selectedOrder = yield select(state => state.orders.selectedOrder);

  if (selectedOrder && selectedOrder.id === order.id) {
    yield put(selectOrder(null));
  }
}
